export default "__VITE_ASSET__C$T0pTOi__"